import {
    IS_FORMATION_LOADING,
    IS_PLAYER_LOADING,
    IS_BADGES_LOADING,
    BADGES_HAS_ERROR,
    BADGES_FETCH_DATA_SUCCESS,
    FORMATIONS_HAS_ERROR,
    FORMATIONS_FETCH_DATA_SUCCESS,
    FORMATIONS_VISIBILITY_UPDATE,
    CREATE_TEAM,
    PLAYERS_HAS_ERROR, PLAYERS_FETCH_DATA_SUCCESS,
    ADD_OR_REMOVE_PLAYER,
    UPDATE_MOBILE_PLAYER_LISTING_VISIBILITY,
    SET_HIGHLIGHT,
    RESET_ERROR,
    MAKE_CAPTAIN,
    REMOVE_CAPTAIN,
    REMOVE_PLAYER,
    SET_TUTORIAL_COOKIE,
    SET_MANAGE_TEAM_TUTORIAL_COOKIE,
    SET_SUBSTITUTION_TUTORIAL_COOKIE,
    RESET_TEAM,
    RESET_COMMON_ERROR,
    AUTO_FILL,
    RESET_API_ERROR,
    OPEN_MOBILE_FILTER,
    SET_BADGE,
    SET_TEAM_NAME,
    IS_TEAM_NAME_VALIDATION_LOADING,
    TEAM_NAME_VALIDATION_HAS_ERROR,
    TEAM_NAME_VALIDATION_FETCH_DATA_SUCCESS,
    IS_CLUBS_LOADING,
    CLUBS_FETCH_DATA_SUCCESS,
    CLUBS_HAS_ERROR,
    SET_CLUB_ID,
    IS_SAVE_TEAM_LOADING,
    SAVE_TEAM_HAS_ERROR,
    SAVE_TEAM_FETCH_DATA_SUCCESS,
    TOGGLE_FILTERS_FOR_WEB,
    TOGGLE_PRIZE_BOX_FOR_WEB,
    TOGGLE_SORT_BY_FOR_WEB,
    TOGGLE_SEARCH_FOR_BOTH,
    APPLY_SEARCH,
    TOGGLE_PRIZE_BOX_FOR_MOBILE,
    APPLY_PRIZE,
    APPLY_PLAYER_SORT,
    APPLY_SORT_BY,
    APPLY_SKILL_FILTER,
    APPLY_CLUB,
    TOGGLE_CLUB_FILTER_FOR_WEB,
    RESET_TEAM_FILTER,
    RESET_FILTER,
    RESET_ALL_FILTER,
    RESET_SKILL_FILTER,
    TOGGLE_PROGRESS_ANIMATION,
    TRIGGER_HANDLE_PLAYER_CARD,
    IS_PLAYER_CARD_LOADING,
    PLAYER_CARD_HAS_ERROR,
    PLAYER_CARD_FETCH_DATA_SUCCESS,
    LIVE_SCORE_FETCH_DATA_SUCCESS,
    IS_LIVE_SCORE_LOADING,
    LIVE_SCORE_HAS_ERROR,
    IS_FIXTURE_LOADING,
    FIXTURE_HAS_ERROR,
    FIXTURE_FETCH_DATA_SUCCESS,
    IS_USER_PLAYED_GAME_DAYS_LOADING,
    USER_PLAYED_GAME_DAYS_HAS_ERROR,
    USER_PLAYED_GAME_DAYS_FETCH_DATA_SUCCESS,
    IS_GET_TEAM_LOADING,
    GET_TEAM_HAS_ERROR,
    GET_TEAM_FETCH_DATA_SUCCESS,
    UPDATE_CURRENT_ACTIVE_FIXTURE,
    CREATE_MANAGE_TEAM_SKELETON,
    RESET_TRANSFERS,
    GET_USER_SPECIFIC_FIXTURES,
    SUBSTITUTE_THIS_PLAYER,
    REPLACE_WITH_THIS_PLAYER,
    CANCEL_SUBSTITUTION,
    RESET_SUBSTITUTION,
    SET_MANAGE_TEAM_MODE,
    RESET_TEAM_DATA,
    RESET_CREATE_TEAM_ERROR,
    IS_TRANSFER_TEAM_LOADING,
    TRANSFER_TEAM_FETCH_DATA_SUCCESS,
    TRANSFER_TEAM_HAS_ERROR,
    IS_LIMITLESS_TEAM_LOADING,
    LIMITLESS_TEAM_FETCH_DATA_SUCCESS,
    LIMITLESS_TEAM_HAS_ERROR,
    IS_SUBSTITUTION_TEAM_LOADING,
    SUBSTITUTION_TEAM_HAS_ERROR,
    SUBSTITUTION_TEAM_FETCH_DATA_SUCCESS,
    REMOVE_ALL,
    IS_CAPTAIN_LOADING,
    CAPTAIN_HAS_ERROR,
    CAPTAIN_FETCH_DATA_SUCCESS,
    SET_POPUP_STATE,
    SET_BOOSTER_POPUP_STATE,
    UPDATE_SAVE_BTN_STATUS,
    IS_SUBSCRIBE_INFO_LOADING,
    SUBSCRIBE_INFO_FETCH_DATA_SUCCESS,
    SUBSCRIBE_INFO_HAS_ERROR,
    IS_UPDATED_TEAM_NAME_LOADING,
    UPDATED_TEAM_NAME_FETCH_DATA_SUCCESS,
    UPDATED_TEAM_NAME_HAS_ERROR,
    IS_DELETE_FANTASY_TEAM_LOADING,
    DELETE_FANTASY_TEAM_FETCH_DATA_SUCCESS,
    DELETE_FANTASY_TEAM_HAS_ERROR,
    TRIGGER_HANDLE_FIXTURE_POPUP,
    UPDATE_BOOSTER_STATUS,
    MIX_FETCH_DATA_SUCCESS,
    SET_TEAM_LOCK_TOAST_COOKIE,
    IS_MATCH_DETAILS_LOADING,
    MATCH_DETAILS_HAS_ERROR,
    MATCH_DETAILS_FETCH_DATA_SUCCESS,
    IS_SHARE_TEAM_LOADING,
    TEAM_SHARE_SUCCESS,
    TEAM_SHARE_ERROR,
    TEAM_SHARE_CLEAR,
    PLAYER_RECOMENDATION_SUCCESS,
    PLAYER_RECOMENDATION_ERROR,
    IS_PLAYER_RECOMENDATION_LOADING,
    SET_PLAYER_RECOMENDATION_FIRST_POPUP_FALSE,
    PLAYER_RECOMENDATION_POPUP_SHOW_HIDE,
    SET_PLAYER_RECOMENDATION_KEY,
    SHOW_PLAYER_RECOMD_MOB_POP_UP,
    SHOW_HIDE_PLAYER_RECOMD_TOGGLE_WEB,
    TOGGLE_SORT_BY_FOR_PLAYER_LIST,
    SHOW_HIDE_PLAYER_RECOM_POP_UP_MOB
} from './../constants/action-types';
import {
    createTeamData,
    addOrRemovePlayer,
    setHighlight,
    makeCaptain,
    removeCaptain,
    autoComplete,
    setBadge,
    setTeamName,
    setClubID,
    sortBy,
    getFixturesToPrint,
    makeManageTeamSkeleton,
    substituteThisPlayer,
    replaceWithThisPlayer,
    cancelSubstitution,
    resetSubstitution,
    resetAll,
    getAutoSubstitutionsApiData
} from "../helper";
import {
    searchBy,
} from "../helper-common";
import config from '../config';
import common from '../common';
import { filter, find, isEmpty, groupBy, findIndex, uniqBy, merge } from 'lodash';


const clone = require('fast-clone');
const tutorialCookie = common.getLocalStorage('tutorial');
const manageTeamTutorialCookie = common.getLocalStorage('manageTeamTutorial');
const substitutionTutorialCookie = common.getLocalStorage('substitutionTutorial');
const initialState = {
    hasError: false,
    isVisible: false,
    hasSeenTutorial: common.isMobile() ? (tutorialCookie && tutorialCookie === true) : true,
    hasSeenManageTeamTutorial: (manageTeamTutorialCookie && manageTeamTutorialCookie === true),
    hasSeenSubstitutionTutorial: (substitutionTutorialCookie && substitutionTutorialCookie === true),
    formations: [],
    players: [],
    groupedPlayers: {},
    teams: [],
    defaultFormation: common.getLocalStorage('defaultFormation') || {},
    defaultFormationIndex: common.getLocalStorage('defaultFormationIndex') || 0,
    teamData: common.getLocalStorage(config.teamDataLocalStorageName) || {},
    teamError: {},
    playerList: [],
    playerListDefault: [],
    currentPosition: {},
    mobilePlayerListingOpen: false,
    mobileFilterOpen: false,
    commonError: null,
    isFormationLoading: false,
    isPlayersLoading: false,
    playerRecomendation: false,
    IsFirstTimeRecomend: true,
    playerRecomendationKeys: [],
    showPlayerRecomendationPopUp: false,
    playerRecomendedSelectedKey: config.playerRecomendationDefault,
    showPlayerRecomMobPopUpFlag: false,
    playerRecomendationToggle: false,
    showPlayerSortPopFlag: false,
    showPlayerrecomendationPopupMobile: false,
    overview: false,
    /*------Filters------*/
    isFilterOpenForWeb: false,
    isPriceBoxOpenForWeb: false,
    isPriceBoxOpenForMobile: false,
    isClubFilterOpenForWeb: false,
    isSortByOpenForWeb: false,
    toggleSortByBoxPlayerListFlag: false,
    isSearchOpenForBoth: false,
    isMoreSortCollapsedForMobile: true,
    searchString: '',
    sortByArr: clone(config.sortByArr),
    priceFilter: clone(config.priceFilter),
    playerFilters: clone(config.playerFilters),
    /*------/Filters------*/
    badgesData: {
        badges: [],
        error: false,
        isFetching: false
    },
    teamNameValidation: {
        response: {},
        error: false,
        isFetching: false
    },
    clubsData: {
        response: [],
        error: false,
        isFetching: false
    },
    savedTeamData: {
        response: {},
        error: false,
        isFetching: false
    },
    willAnimate: false,
    isPlayerCardVisible: false,
    playerCardDetails: null,
    playerData: {
        pData: {},
        matchData: [],
        error: false,
        isFetching: false
    },
    mode: 'pre',
    liveScore: {
        response: [],
        error: false,
        isFetching: false
    },
    /*Manage Team*/
    isFixtureLoading: false,
    isFixtureError: false,
    isUserPlayedGameDaysLoading: false,
    isUserPlayedGameDaysError: false,
    isGetTeamLoading: false,
    isGetTeamError: false,
    fixtures: [],
    userSpecificFixtures: [],
    userPlayedMatchDays: [],
    currentActiveFixture: 0,
    manageTeamRawData: {},
    getTeam: {},
    manageTeamMode: 1,
    savedTransferData: {
        response: {},
        error: false,
        isFetching: false
    },
    savedLimitlessData: {
        response: {},
        error: false,
        isFetching: false
    },
    savedSubstitutionData: {
        response: {},
        error: false,
        isFetching: false
    },
    savedCaptainData: {
        response: {},
        error: false,
        isFetching: false
    },
    popupState: {
        showPopup: false
    },
    saveBtnStatus: false,
    isSubscribeInfoLoading: false,
    subscribeInfoHasError: false,
    subscribeInfo: {},
    updateTeamNameData: {
        response: {},
        error: false,
        isFetching: false
    },
    deleteFantasyTeamData: {
        response: {},
        error: false,
        isFetching: false
    },
    isFixturePopupVisible: false,
    boosterPopupState: {
        showBoosterPopup: false
    },
    mixResponse: {},
    matchDetails: {},
    shareUrl: "",
    isMatchDetailsLoading: false,
    gameday: false
};
export default function formationData(state = initialState, action) {
    const getLastSkill = (highlightedSkill) => {
        const thisHighlightedSkill = highlightedSkill || {};
        const skill = thisHighlightedSkill.skill;
        const lastSkill = common.getLocalStorage('lastSkill') || config.EnumPosition.Forwards;
        return (skill || lastSkill);
    };
    const saveMyTeamData = (teamData) => {
        window.teamData = teamData;
        if (!common.isManageTeam()) {
            common.setLocalStorage(config.teamDataLocalStorageName, teamData);
        }
    };
    const filterList = (playerListRaw, playerFilters, budget) => {
        let sortByOption = playerFilters.sortBy;
        if (playerFilters.playerRecomendation[0] != config.playerRecomendationDefault) {
            sortByOption = playerFilters.playerRecomendation[0];
        }
        const teamIDsToFilter = playerFilters.teamIds;
        const selectedPriceFilter = state.priceFilter.filter(
            item => playerFilters.priceFilterSelected.indexOf(item.id) > -1
        );
        const playerList = playerListRaw.filter(player => {
            return player.IsActive && (teamIDsToFilter.length ? (teamIDsToFilter.indexOf(player.TID) > -1) : true) && (selectedPriceFilter.length ? (selectedPriceFilter.some(item => {
                if (item.id == 100) {
                    return player
                } else if (item.id == 101) {// budget affordable
                    return player['Value'] <= parseFloat(budget ? budget : state.teamData.budget);
                } else {
                    return player['Value'] <= item.max;
                }
            })) : true) && (playerFilters.searchString ? searchBy(player, ['PFName', 'TName'], playerFilters.searchString) : true)

        });

        let sortedPlayerList = sortBy(playerList, sortByOption);;

        let finalSorteddlist = [];
        if (playerFilters.skillId.length > 0 && playerFilters.skillId.indexOf(0) < 0) {
            if (playerFilters.searchString != "") {
                const searchByPlayerList = sortedPlayerList.filter(player => {
                    return (playerFilters.searchString ? searchBy(player, ['PFName', 'TName'], playerFilters.searchString) : true)
                })
                finalSorteddlist = searchByPlayerList;
            } else {
                finalSorteddlist = filter(sortedPlayerList, (item) => { return playerFilters.skillId.indexOf(item.Skill) > -1 });
            }

        } else {
            finalSorteddlist = sortedPlayerList;
        }

        //  //check if player status is applied
        if (sortedPlayerList.length) {
            let isSortByPlayerApplied = false;
            var playerStatusColl = [];
            for (var o = 0; o < playerFilters.playerStatus.length; o++) {
                for (var k = 0; k < sortedPlayerList.length; k++) {
                    if (sortedPlayerList[k].PStatus == playerFilters.playerStatus[o].id && playerFilters.playerStatus[o].active == true) {

                        let player = sortedPlayerList[k];
                        //also check for the other filters applied
                        if (player.IsActive && (teamIDsToFilter.length ? (teamIDsToFilter.indexOf(player.TID) > -1) : true) && playerFilters.skillId.length ? playerFilters.skillId.indexOf(player.Skill) > -1 || (playerFilters.skillId.indexOf(0) > -1) : true) {
                            playerStatusColl.push(sortedPlayerList[k]);
                        }

                    }
                    if (playerFilters.playerStatus[o].active == true) {
                        isSortByPlayerApplied = true;
                    }

                }
            }
            if (isSortByPlayerApplied) {
                finalSorteddlist = playerStatusColl;
            } else {
                finalSorteddlist = finalSorteddlist;

            }
        }


        //check if playerrecomendation filter applied then slice 20
        if (playerFilters.playerRecomendation[0] != config.playerRecomendationDefault) {
            let sortedPlayers = sortBy(finalSorteddlist, sortByOption, 'DESC', true)
            let filteredPlayers = sortedPlayers.filter((player, idx) => { return player[sortByOption] > 0 })
            return filteredPlayers//.slice(0, config.recomendedListCount);
        } else {
            return finalSorteddlist;
        }



    };
    const barGraphData = (popStats) => {
        let uniqueFixture = uniqBy(popStats.Fixtures, 'GDID');
        return uniqueFixture.map(item => {
            let points = find(popStats.Points, { MID: item.MID });
            let stats = find(popStats.Stats, { MID: item.MID });
            item.points = points;
            item.stats = stats;
            return item;
        });
    }
    const findMode = (fixtures) => {
        return fixtures.some(item => +item.MStatus === 1);
    }
    const calculatePercentile = (popStats) => {
        let barGraph = barGraphData(popStats);
        const flatAllPoints = barGraph.map(el => el.points.TPoints);
        const maxTotalPoints = Math.max.apply(undefined, flatAllPoints);
        barGraph = barGraph.map(fixture => {
            fixture.totalPointPercent =
                +maxTotalPoints === 0
                    ? 0
                    : (fixture.points.TPoints / maxTotalPoints) * 100;
            return fixture;
        });
        return barGraph;
    }
    const makeObj = (data) => {
        const stats = ['OF', 'CS', 'GA', 'GC', 'GS', 'OG', 'PC', 'PE', 'PM', 'PS', 'RC', 'SS', 'YC', 'TPoints', 'BR', 'GOB'];
        const obj = {};
        for (let i = 0; i < stats.length; i++) {
            obj[stats[i]] = data[stats[i]];
        }
        return obj;
    }
    switch (action.type) {
        case IS_FORMATION_LOADING: {
            return { ...state, isFormationLoading: action.payload };
        }
        case IS_PLAYER_LOADING: {
            return { ...state, isPlayersLoading: action.payload };
        }
        case IS_BADGES_LOADING: {
            return { ...state, badgesData: { ...state.badgesData, isFetching: action.payload } };
        }
        case BADGES_HAS_ERROR: {
            return { ...state, hasError: action.payload };
        }
        case BADGES_FETCH_DATA_SUCCESS: {
            const badges = filter(action.payload['Data']['Value'], { IsActive: 1 });
            return { ...state, badgesData: { ...state.badgesData, ...{ badges } } };
        }
        case SET_TUTORIAL_COOKIE: {
            common.setLocalStorage('tutorial', true);
            return { ...state, hasSeenTutorial: true };
        }
        case SET_MANAGE_TEAM_TUTORIAL_COOKIE: {
            common.setLocalStorage('manageTeamTutorial', true);
            return { ...state, hasSeenManageTeamTutorial: true };
        }
        case SET_SUBSTITUTION_TUTORIAL_COOKIE: {
            common.setLocalStorage('substitutionTutorial', true);
            return { ...state, hasSeenSubstitutionTutorial: true };
        }
        case FORMATIONS_HAS_ERROR:
            return { ...state, hasError: action.payload };
        case FORMATIONS_FETCH_DATA_SUCCESS: {
            const formationsData = action.payload['Data']['Value'];
            const defaultFormationFromStorage = common.getLocalStorage('defaultFormation');
            if (defaultFormationFromStorage) {
                let selForm = find(formationsData, { IsDefault: true });
                selForm.IsDefault = false;
            }
            const defaultFormation = defaultFormationFromStorage || find(formationsData, formation => formation.IsDefault);
            const defaultFormationIndex = common.getLocalStorage('defaultFormationIndex') || defaultFormation.CompId;
            common.setLocalStorage('defaultFormation', defaultFormation);
            common.setLocalStorage('defaultFormationIndex', defaultFormationIndex);
            return {
                ...state,
                formations: formationsData,
                defaultFormation: defaultFormation,
                defaultFormationIndex: defaultFormationIndex
            };
        }
        case PLAYERS_HAS_ERROR:
            return { ...state, hasError: action.payload };
        case PLAYERS_FETCH_DATA_SUCCESS: {
            const payload = action.payload['Data']['Value'];
            const players = payload.playerList;
            const playerListDefault = clone(payload.playerList);
            const groupedPlayers = groupBy(players, 'Skill');
            const playerRecomendation = payload.PlayerRecom ? payload.PlayerRecom : false;


            let IsFirstTimeRecomend = "";

            if (common.getLocalStorage("IsFirstTimeRecomend") == false) {
                IsFirstTimeRecomend = false;
            } else if (common.getLocalStorage("IsFirstTimeRecomend") == true) {
                IsFirstTimeRecomend = true;
            } else {
                IsFirstTimeRecomend = true;
            }

            return { ...state, players, groupedPlayers, teams: payload['teamsList'], playerRecomendation, IsFirstTimeRecomend, playerListDefault };
        }

        case SHOW_PLAYER_RECOMD_MOB_POP_UP: {
            let showPlayerRecomMobPopUpFlag = false;
            if (action.payload == true) {
                showPlayerRecomMobPopUpFlag = true;
            }
            return { ...state, showPlayerRecomMobPopUpFlag }
        }

        case SHOW_HIDE_PLAYER_RECOM_POP_UP_MOB: {
            let showPlayerrecomendationPopupMobile = action.payload;
            return { ...state, showPlayerrecomendationPopupMobile }
        }


        case SET_PLAYER_RECOMENDATION_FIRST_POPUP_FALSE: {
            let IsFirstTimeRecomend = false;
            common.setLocalStorage('IsFirstTimeRecomend', false);
            return { ...state, IsFirstTimeRecomend };
        }


        case PLAYER_RECOMENDATION_POPUP_SHOW_HIDE: {
            let showPlayerRecomendationPopUp = action.payload;
            let showPlayerRecomMobPopUpFlag = false;
            let playerRecomendationToggle = false;
            if (action.payload === false) {
                showPlayerRecomMobPopUpFlag = true;
                playerRecomendationToggle = true;
            } else if (action.payload === "") {
                showPlayerRecomendationPopUp = true;
                playerRecomendationToggle = false;
            } else {

            }

            return { ...state, showPlayerRecomendationPopUp, showPlayerRecomMobPopUpFlag, playerRecomendationToggle };
        }

        case SHOW_HIDE_PLAYER_RECOMD_TOGGLE_WEB: {
            let playerRecomendationToggle = action.payload;
            if (action.payload === "") {
                playerRecomendationToggle = state.playerRecomendationToggle;
            }
            return { ...state, playerRecomendationToggle };
        }
        case PLAYERS_HAS_ERROR: {
            return { ...state, hasError: action.payload };
        }
        case PLAYER_RECOMENDATION_SUCCESS: {
            common.hideLoader();
            let playerRecomendationKeys = filter(action.payload['Data']['Value'], { IsActive: 1 });
            for (var k = 0; k < playerRecomendationKeys.length; k++) {
                if (playerRecomendationKeys[k].Key == 'lastGdPoints') {
                    playerRecomendationKeys[k].Key = 'lastGdPointRecomendation';
                }
            }
            const playerRecomendedSelectedKey = config.playerRecomendationDefault;
            return { ...state, playerRecomendationKeys: playerRecomendationKeys, playerRecomendedSelectedKey };
        }

        case SET_PLAYER_RECOMENDATION_KEY: {
            let playerRecomendedSelectedKey = action.payload.Key;

            if (state.playerRecomendedSelectedKey != playerRecomendedSelectedKey) {
                if (state.playerRecomendedSelectedKey == config.playerRecomendationDefault && playerRecomendedSelectedKey != config.playerRecomendationDefault) {
                    ++state.playerFilters.filterCount;
                }
                if (state.playerRecomendedSelectedKey != config.playerRecomendationDefault && playerRecomendedSelectedKey == config.playerRecomendationDefault) {
                    --state.playerFilters.filterCount;
                }

            } else {
                if (state.playerRecomendedSelectedKey == playerRecomendedSelectedKey) {
                    --state.playerFilters.filterCount;
                }
            }


            let playerFilters = clone(state.playerFilters);

            let index = state.playerFilters.playerRecomendation.indexOf(playerRecomendedSelectedKey);
            if (index > -1) {
                playerFilters.playerRecomendation = [config.playerRecomendationDefault];
                playerRecomendedSelectedKey = config.playerRecomendationDefault;
            } else {
                playerFilters.playerRecomendation = [playerRecomendedSelectedKey];
                playerRecomendedSelectedKey = playerRecomendedSelectedKey;

            }

            if (playerRecomendedSelectedKey != config.playerRecomendationDefault) {
                playerFilters.sortBy = config.defaultSortBy;
            }
            // let playerListUnsorted = filterList(action.playerList, playerFilters);
            let playerListUnsorted = sortBy(action.playerList, state.playerFilters.sortBy);
            playerFilters.sortBy = state.playerFilters.sortBy;
            let playerList = playerListUnsorted;
            // if (playerRecomendedSelectedKey == config.playerRecomendationDefault) {
            playerList = filterList(state.playerListDefault, playerFilters) //uncomment this if issue is faced for player list filters
            // }

            return { ...state, playerRecomendedSelectedKey, playerList, playerFilters };


        }

        case PLAYER_RECOMENDATION_ERROR: {
            return { ...state, hasError: action.payload };
        }
        case IS_PLAYER_RECOMENDATION_LOADING: {
            return { ...state, isPlayerRecomendationLoading: action.payload };
        }
        case FORMATIONS_VISIBILITY_UPDATE:
            return { ...state, isVisible: !state.isVisible };
        case CREATE_TEAM: {
            let newState = { ...state };
            const { constraints, oldFormationId, newFormationId } = action.payload;
            let { formations, teamData, manageTeamRawData } = newState, playerPos = config.playerPos;
            if (isEmpty(teamData) || oldFormationId) {
                teamData = createTeamData({
                    constraints,
                    formations,
                    newFormationId,
                    oldFormationId,
                    teamData,
                    playerPos
                });
                let lastFormation = find(newState.formations, formation => (+formation.CompId === +oldFormationId));
                oldFormationId && (lastFormation.IsDefault = false);
            }
            /* reset substitution data */
            resetSubstitution(teamData);
            if (common.isManageTeam()) {
                teamData = getAutoSubstitutionsApiData(teamData, manageTeamRawData);
            }
            let newFormation = find(newState.formations, formation => (+formation.CompId === +newFormationId));
            newFormation.IsDefault = true;
            const { highlightedSkill } = teamData;
            const lastSkill = getLastSkill(highlightedSkill);
            // const playerListRaw = newState.groupedPlayers[lastSkill];
            const playerListRaw = newState.players;
            const playerList = filterList(playerListRaw, state.playerFilters);
            saveMyTeamData(teamData);
            common.setLocalStorage('defaultFormation', newFormation);
            common.setLocalStorage('defaultFormationIndex', newFormationId);
            lastSkill && common.setLocalStorage('lastSkill', lastSkill);
            let data = {
                ...newState,
                teamData,
                playerList,
                defaultFormation: newFormation,
                defaultFormationIndex: newFormationId,
                isVisible: false
            };
            if (!isEmpty(highlightedSkill)) {
                data.currentPosition = highlightedSkill;
            }
            // data.teamData = setHighlight(data.teamData, 'isHighlighted', null, lastSkill)
            return data;
        }
        case ADD_OR_REMOVE_PLAYER: {
            const player = action.payload;
            let newState = { ...state };
            const currentPosition = newState.currentPosition;
            const manipulatedResponse = addOrRemovePlayer(newState.teamData, player, player.Skill, currentPosition.rowIndex, currentPosition.playerIndex, newState.manageTeamRawData, newState.playerFilters.skillId);
            const teamData = manipulatedResponse.teamData;
            const teamError = manipulatedResponse.errorObj;
            let isPlayerCardVisible = state.isPlayerCardVisible ? true : false;
            if (teamError.playersPerSkillCountExceeded || teamError.playersPerTeamCountExceeded) {
                isPlayerCardVisible = false;
            }
            const { highlightedSkill } = teamData;
            const lastSkill = getLastSkill(highlightedSkill);
            // const playerListRaw = newState.groupedPlayers[lastSkill];
            const playerListRaw = newState.players;

            const playerList = filterList(playerListRaw, state.playerFilters, manipulatedResponse.teamData.budget);
            saveMyTeamData(teamData);
            let data = {
                ...newState,
                teamData,
                playerList,
                teamError,
                isPlayerCardVisible
            };
            if (!isEmpty(highlightedSkill)) {
                common.setLocalStorage('lastSkill', highlightedSkill.skill);
                data.currentPosition = highlightedSkill;
            }
            return data;
        }
        case REMOVE_PLAYER: {
            let newState = { ...state };
            const { player, objKey, playerIndex } = action.payload;
            const manipulatedResponse = addOrRemovePlayer(newState.teamData, player, player.Skill, objKey, playerIndex, newState.manageTeamRawData, newState.playerFilters.skillId);
            const teamData = manipulatedResponse.teamData;
            const teamError = manipulatedResponse.errorObj;
            let isPlayerCardVisible = state.isPlayerCardVisible;
            if (state.isPlayerCardVisible) {
                isPlayerCardVisible = false;
            }


            const { highlightedSkill } = teamData;
            const lastSkill = getLastSkill(highlightedSkill);
            // const playerListRaw = newState.groupedPlayers[lastSkill];
            const playerListRaw = newState.players;
            const playerList = filterList(playerListRaw, state.playerFilters, manipulatedResponse.teamData.budget);
            saveMyTeamData(teamData);
            lastSkill && common.setLocalStorage('lastSkill', lastSkill);
            return {
                ...newState,
                teamData,
                teamError,
                playerList,
                currentPosition: highlightedSkill,
                isPlayerCardVisible
            };
        }
        case UPDATE_MOBILE_PLAYER_LISTING_VISIBILITY: {
            //get filtercount
            let filterCount = 0;
            let priseCount = state.playerFilters.priceFilterSelected[0] == 100 ? 0 : 1;
            let skillCount = state.playerFilters.skillId.length;
            let teamCount = state.playerFilters.teamIds.length;
            let playerRecomendationCount = state.playerRecomendedSelectedKey == config.playerRecomendationDefault ? 0 : 1;
            filterCount = priseCount + skillCount + teamCount + playerRecomendationCount;
            state.playerFilters.filterCount = filterCount;
            let newState = { ...state, playerFilters: { ...state.playerFilters } };
            return { ...newState, mobilePlayerListingOpen: action.payload };
        }
        case RESET_ERROR: {
            let newState = { ...state };
            return { ...newState, teamError: {} };
        }
        case RESET_COMMON_ERROR: {
            let newState = { ...state };
            return { ...newState, commonError: null };
        }
        case MAKE_CAPTAIN: {
            let newState = { ...state };
            const { player, objKey, playerIndex } = action.payload;
            const teamData = makeCaptain({ ...state.teamData }, objKey, playerIndex, player);
            saveMyTeamData(teamData);
            return { ...newState, teamData };
        }
        case REMOVE_CAPTAIN: {
            let newState = { ...state };
            const { objKey, playerIndex } = action.payload;
            const teamData = removeCaptain({ ...state.teamData }, objKey, playerIndex);
            saveMyTeamData(teamData);
            return { ...newState, teamData };
        }
        case SET_HIGHLIGHT: {
            const { player, objKey, playerIndex } = action.payload;
            const teamData = setHighlight({ ...state.teamData }, objKey, playerIndex);
            const highlightedSkill = player.skill;
            const currentPosition = { skill: highlightedSkill, rowIndex: objKey, playerIndex };
            const playerListRaw = state.players;
            state.playerFilters.skillId = [player.skill];
            const playerList = filterList(playerListRaw, state.playerFilters);
            saveMyTeamData(teamData);
            return { ...state, teamData, playerList, currentPosition };
        }
        case RESET_TEAM: {
            common.customTracking('Reset Team');
            let newState = { ...state };
            let { constraints, oldFormationId, newFormationId, teamData } = action.payload;
            let { formations } = newState, playerPos = config.playerPos;
            if (isEmpty(teamData)) {
                teamData = createTeamData({
                    constraints,
                    formations,
                    newFormationId,
                    oldFormationId,
                    teamData,
                    playerPos
                });
                let lastFormation = find(newState.formations, formation => (+formation.CompId === +oldFormationId));
                oldFormationId && (lastFormation.IsDefault = false);
            }
            const { highlightedSkill } = teamData;
            const lastSkill = getLastSkill(highlightedSkill);
            // const playerListRaw = newState.groupedPlayers[lastSkill];
            const playerListRaw = newState.players;
            //if required we can reset the entire filters too but for now resetting only skills
            // state.playerFilters.skillId = config.playerFilters.skillId;
            const playerList = filterList(playerListRaw, state.playerFilters, teamData.budget);
            saveMyTeamData(teamData);
            lastSkill && common.setLocalStorage('lastSkill', lastSkill);
            let data = {
                ...newState,
                teamData,
                playerList,
                currentPosition: highlightedSkill,
            };
            if (!isEmpty(highlightedSkill)) {
                data.currentPosition = highlightedSkill;
            }
            return data;
        }
        case AUTO_FILL: {
            let { manageTeamRawData, groupedPlayers } = state;
            const { teamData, errorObj } = autoComplete(state.teamData, groupedPlayers, manageTeamRawData);
            saveMyTeamData(teamData);
            let playerFilters = clone(state.playerFilters);
            const playerListRaw = state.players;
            const playerList = filterList(playerListRaw, playerFilters, teamData.budget);
            return { ...state, teamData, commonError: errorObj.isAutofillError ? 'autoFillError' : null, playerList };
        }
        case OPEN_MOBILE_FILTER: {
            return { ...state, mobileFilterOpen: action.payload };
        }
        case RESET_API_ERROR: {
            return { ...state, hasError: false };
        }
        case SET_BADGE: {
            const teamData = setBadge(state.teamData, action.payload);
            saveMyTeamData(teamData);
            return { ...state, teamData };
        }
        case SET_TEAM_NAME: {
            const teamData = setTeamName(state.teamData, action.payload);
            saveMyTeamData(teamData);
            return { ...state, teamData };
        }
        case SET_CLUB_ID: {
            const teamData = setClubID(state.teamData, action.payload);
            saveMyTeamData(teamData);
            return { ...state, teamData };
        }
        case IS_TEAM_NAME_VALIDATION_LOADING: {
            return { ...state, teamNameValidation: { ...state.teamNameValidation, isFetching: action.payload } };
        }
        case TEAM_NAME_VALIDATION_HAS_ERROR: {
            return { ...state, teamNameValidation: { ...state.teamNameValidation, error: action.payload } };
        }
        case TEAM_NAME_VALIDATION_FETCH_DATA_SUCCESS: {
            return { ...state, teamNameValidation: { ...state.teamNameValidation, response: action.payload } };
        }
        case IS_CLUBS_LOADING: {
            return { ...state, clubsData: { ...state.clubsData, isFetching: action.payload } };
        }
        case CLUBS_HAS_ERROR: {
            return { ...state, clubsData: { ...state.clubsData, error: action.payload } };
        }
        case CLUBS_FETCH_DATA_SUCCESS: {
            return { ...state, clubsData: { ...state.clubsData, response: action.payload['Data']['Value'] } };
        }
        case IS_SAVE_TEAM_LOADING: {
            return { ...state, savedTeamData: { ...state.savedTeamData, isFetching: action.payload } };
        }
        case SAVE_TEAM_HAS_ERROR: {
            return { ...state, savedTeamData: { ...state.savedTeamData, error: action.payload } };
        }
        case SAVE_TEAM_FETCH_DATA_SUCCESS: {


            return { ...state, savedTeamData: { ...state.savedTeamData, response: action.payload } };
        }
        case TOGGLE_FILTERS_FOR_WEB: {
            return { ...state, isFilterOpenForWeb: !state.isFilterOpenForWeb };
        }
        case TOGGLE_PRIZE_BOX_FOR_WEB: {
            return { ...state, isPriceBoxOpenForWeb: !state.isPriceBoxOpenForWeb };
        }
        case TOGGLE_SORT_BY_FOR_WEB: {
            return { ...state, isSortByOpenForWeb: !state.isSortByOpenForWeb };
        }
        case TOGGLE_SORT_BY_FOR_PLAYER_LIST: {
            return { ...state, showPlayerSortPopFlag: !state.showPlayerSortPopFlag };
        }
        case TOGGLE_CLUB_FILTER_FOR_WEB: {
            return { ...state, isClubFilterOpenForWeb: !state.isClubFilterOpenForWeb };
        }
        case TOGGLE_PRIZE_BOX_FOR_MOBILE: {
            return { ...state, isPriceBoxOpenForMobile: !state.isPriceBoxOpenForMobile };
        }
        case TOGGLE_SEARCH_FOR_BOTH: {
            const newState = typeof (action.payload) === typeof (true) ? action.payload : !state.isSearchOpenForBoth;
            return { ...state, isSearchOpenForBoth: newState };
        }
        case APPLY_SEARCH: {
            const { highlightedSkill } = state.teamData;
            const lastSkill = getLastSkill(highlightedSkill);
            // const playerListRaw = state.groupedPlayers[lastSkill];
            const playerListRaw = state.players;
            const playerFilters = { ...state.playerFilters, searchString: action.payload };
            const playerList = filterList(playerListRaw, playerFilters);
            return { ...state, playerList, playerFilters };
        }
        case APPLY_PRIZE: {
            let priceID = action.payload;
            let priceToBereset = "";

            if (state.playerFilters.priceFilterSelected[0] == 100 && priceID != 100) {
                ++state.playerFilters.filterCount;
            } else {
                // do nothing
                if (state.playerFilters.priceFilterSelected[0] == priceID && priceID != 100) {
                    if (state.playerFilters.filterCount > 0) {
                        --state.playerFilters.filterCount;
                        priceToBereset = 100;

                    }
                }

                if (state.playerFilters.priceFilterSelected[0] != 100 && priceID == 100) {
                    if (state.playerFilters.filterCount > 0) {
                        --state.playerFilters.filterCount;
                        priceToBereset = 100;
                    }
                }
            }

            if (priceToBereset) {
                priceID = priceToBereset;
            }

            state.playerFilters.priceFilterSelected = [priceID];

            let playerFilters = clone(state.playerFilters);

            const { highlightedSkill } = state.teamData;
            const lastSkill = getLastSkill(highlightedSkill);
            const playerListRaw = state.players;

            const playerList = filterList(playerListRaw, playerFilters);
            return { ...state, playerList, playerFilters };
        }

        case APPLY_PLAYER_SORT: {
            const playerSort = action.payload;
            const playerSortId = action.payload.id;

            for (var i = 0; i < state.playerFilters.playerStatus.length; i++) {
                if (state.playerFilters.playerStatus[i].id == playerSortId) {
                    if (state.playerFilters.playerStatus[i].active == true) {
                        state.playerFilters.playerStatus[i].active = false;
                        --state.playerFilters.filterCount;
                    } else {
                        common.customTracking('Select Show Filter - ' + playerSort.label, common.getPageName());
                        state.playerFilters.playerStatus[i].active = true;
                        ++state.playerFilters.filterCount;
                    }
                }
            }




            let playerFilters = clone(state.playerFilters);
            playerFilters.playerStatus = [...state.playerFilters.playerStatus];
            const playerListRaw = state.players;
            const playerList = filterList(playerListRaw, playerFilters);
            return { ...state, playerList, playerFilters };
        }



        case APPLY_CLUB: {
            const teamID = action.payload['TID'];
            const teamName = action.payload['OfficialName'];
            const teamNameWeb = action.payload['WebName'];
            let index = state.playerFilters.teamIds.indexOf(teamID);
            if (index > -1) {
                --state.playerFilters.filterCount;
                state.playerFilters.teamIds.splice(index, 1);
                state.playerFilters.teamNamesObj.splice(index, 1);
            } else {
                common.customTracking('Select Club filter - ' + teamNameWeb, common.getPageName());
                ++state.playerFilters.filterCount;
                state.playerFilters.teamIds.push(teamID);
                state.playerFilters.teamNamesObj.push(teamName);
            }
            const { highlightedSkill } = state.teamData;
            const lastSkill = getLastSkill(highlightedSkill);
            let playerFilters = clone(state.playerFilters);
            playerFilters.teamIds = [...state.playerFilters.teamIds];
            playerFilters.teamNamesObj = [...state.playerFilters.teamNamesObj];
            // const playerListRaw = state.groupedPlayers[lastSkill];
            const playerListRaw = state.players;
            const playerList = filterList(playerListRaw, playerFilters);
            return { ...state, playerList, playerFilters };
        }
        case APPLY_SORT_BY: {
            const { highlightedSkill } = state.teamData;
            const lastSkill = getLastSkill(highlightedSkill);
            // const playerListRaw = state.groupedPlayers[lastSkill];
            const playerListRaw = state.players;
            const playerFilters = { ...state.playerFilters, sortBy: action.payload };
            const playerList = filterList(playerListRaw, playerFilters);
            const showPlayerSortPopFlag = false;
            return { ...state, playerList, playerFilters, showPlayerSortPopFlag };
        }

        case APPLY_SKILL_FILTER: {
            if (state.playerFilters.skillId.indexOf(action.payload) > -1) {
                //remove
                state.playerFilters.skillId.splice(state.playerFilters.skillId.indexOf(action.payload), 1);
                if (state.playerFilters.filterCount > 0) {
                    --state.playerFilters.filterCount;
                }

            } else {
                //add
                state.playerFilters.skillId.push(action.payload);
                ++state.playerFilters.filterCount;
            }

            if (action.payload == 0) {
                state.playerFilters.skillId = [0]
            } else {
                if (state.playerFilters.skillId.indexOf(0) > -1) {
                    state.playerFilters.skillId.splice(state.playerFilters.skillId.indexOf(0), 1)
                }

            }



            let playerFilters = clone(state.playerFilters);
            playerFilters.skillId = [...state.playerFilters.skillId];
            const playerListRaw = state.players;
            const playerList = filterList(playerListRaw, playerFilters);
            return { ...state, playerList, playerFilters };
        }
        case RESET_TEAM_FILTER: {

            const { highlightedSkill } = state.teamData;
            const lastSkill = getLastSkill(highlightedSkill);
            // const playerListRaw = state.groupedPlayers[lastSkill];
            const playerListRaw = state.players;
            const playerFilters = clone(state.playerFilters);
            const affectedFilterCount = playerFilters.teamIds.length;
            playerFilters.teamIds = [];
            playerFilters.filterCount = playerFilters.filterCount - affectedFilterCount;
            const playerList = filterList(playerListRaw, playerFilters);
            return {
                ...state,
                playerList,
                playerFilters: playerFilters,
            };
        }
        case RESET_FILTER: {
            const { highlightedSkill } = state.teamData;
            const lastSkill = getLastSkill(highlightedSkill);
            const playerListRaw = state.players;
            const sortBy = state.playerFilters.sortBy;

            let playerFilters = clone(config.playerFilters);
            playerFilters.playerRecomendation = [config.playerRecomendationDefault];
            let playerRecomendedSelectedKey = config.playerRecomendationDefault;
            playerFilters.sortBy = sortBy;
            playerFilters.filterCount = 0;
            const playerList = filterList(playerListRaw, playerFilters);
            playerFilters = {
                sortBy: 'TotPts',
                searchString: '',
                teamIds: [],
                teamNamesObj: [],
                priceFilterSelected: [100],
                curPosFilter: 1,
                skillId: [],
                filterCount: 0,
                playerStatus: [{
                    id: "I", label: "injured", siIcon: "si-injured", active: false
                }, {
                    id: "S", label: "suspended", siIcon: "si-suspended", active: false
                }],
                playerRecomendation: ["playerRecomendationdDefault"]
            }
            return {
                ...state,
                playerList,
                playerFilters,
                playerRecomendedSelectedKey
            };
        }
        case RESET_ALL_FILTER: {
            const { highlightedSkill } = state.teamData;
            const lastSkill = getLastSkill(highlightedSkill);
            // const playerListRaw = state.groupedPlayers[lastSkill];
            const playerListRaw = state.players;
            let playerFilters = clone(config.playerFilters);

            let playerList = [];
            if (playerListRaw) {
                playerList = filterList(playerListRaw, playerFilters);
            }
            let playerRecomendedSelectedKey = config.playerRecomendationDefault;
            playerFilters = {
                sortBy: 'TotPts',
                searchString: '',
                teamIds: [],
                teamNamesObj: [],
                priceFilterSelected: [100],
                curPosFilter: 1,
                skillId: [],
                filterCount: 0,
                playerStatus: [{
                    id: "I", label: "injured", siIcon: "si-injured", active: false
                }, {
                    id: "S", label: "suspended", siIcon: "si-suspended", active: false
                }],
                playerRecomendation: ["playerRecomendationdDefault"]
            }

            return {
                ...state,
                isFilterOpenForWeb: false,
                isPriceBoxOpenForWeb: false,
                isPriceBoxOpenForMobile: false,
                isClubFilterOpenForWeb: false,
                isSortByOpenForWeb: false,
                isSearchOpenForBoth: false,
                isMoreSortCollapsedForMobile: true,
                searchString: '',
                sortByArr: clone(config.sortByArr),
                priceFilter: clone(config.priceFilter),
                playerFilters: playerFilters,
                playerList,
                playerRecomendedSelectedKey,

            };
        }
        case RESET_SKILL_FILTER: {
            const playerFilters = clone(state.playerFilters);
            playerFilters.skillId = [];
            return {
                ...state,
                playerFilters: playerFilters,
            };
        }
        case TOGGLE_PROGRESS_ANIMATION: {
            return {
                ...state,
                willAnimate: action.payload,
            };
        }
        case TRIGGER_HANDLE_PLAYER_CARD: {
            const newState = { ...state };
            if (action.payload.isPlayerCardVisible === false) {
                newState.playerData.pData = {};
            }
            newState.isPlayerCardVisible = action.payload.isPlayerCardVisible;
            newState.playerCardDetails = action.payload.playerObj;
            if (action.payload.playerInfoClicked != undefined || action.payload.playerInfoClicked != null) {
                newState.playerInfoClicked = action.payload.playerInfoClicked;
            }

            if (action.payload.isPlayerCardVisible === false) {
                newState.playerInfoClicked = false;
            }
            if (action.payload.overviewValue) {
                newState.overview = true;
            } else {
                newState.overview = false;
            }
            newState.gameday = action.payload.gameday;

            return {
                ...newState,
            }
        }
        case IS_PLAYER_CARD_LOADING: {
            return { ...state, playerData: { ...state.playerData, isFetching: action.payload } };
        }
        case PLAYER_CARD_HAS_ERROR: {
            return { ...state, hasError: action.payload };
        }
        case PLAYER_CARD_FETCH_DATA_SUCCESS: {
            const pData = action.payload['Data']['Value'];
            const liveScore = (state.liveScore && state.liveScore.response) || [];
            const playerId = pData.Id;
            for (let i = 0; i < liveScore.length; i++) {
                const match = liveScore[i];
                const Mid = match.MID;
                const liveScoreLine = match.ScoreLine;
                const livePointsPlayer = filter(match.PPoints, { PID: playerId });
                const liveStatsPlayer = filter(match.PStats, { PID: playerId });
                if (livePointsPlayer.length > 0) {
                    const playerPoints = pData.Points;
                    const playerStats = pData.Stats;
                    const playerFixtures = pData.Fixtures;
                    for (let j = 0; j < playerPoints.length; j++) {
                        let plyrPoints = playerPoints[j];
                        if (+plyrPoints["MID"] === +Mid) {
                            const mergeContent = makeObj(livePointsPlayer[0]);
                            plyrPoints = merge(plyrPoints, mergeContent);
                            break;
                        }
                    }
                    for (let j = 0; j < playerStats.length; j++) {
                        let plyrStats = playerStats[j];
                        if (+plyrStats["MID"] === +Mid) {
                            const mergeContent = makeObj(liveStatsPlayer[0]);
                            plyrStats = merge(plyrStats, mergeContent);
                            break;
                        }
                    }
                    for (let j = 0; j < playerFixtures.length; j++) {
                        let plyrFixtures = playerFixtures[j];
                        if (+plyrFixtures["MID"] === +Mid) {
                            let plyrFixtures = playerFixtures[j];
                            if (+liveScoreLine[0].TID === +plyrFixtures.HTID) {
                                plyrFixtures.HTScr = liveScoreLine[0].GS;
                                plyrFixtures.ATScr = liveScoreLine[1].GS;
                            } else if (+liveScoreLine[0].TID === +plyrFixtures.ATID) {
                                plyrFixtures.HTScr = liveScoreLine[1].GS;
                                plyrFixtures.ATScr = liveScoreLine[0].GS;
                            }
                            plyrFixtures.MMinutes = match.MinuteString;
                            plyrFixtures.Phase = match.Phase;
                            plyrFixtures.liveStatus = match.Status;
                            break;
                        }
                    }
                }
            }
            let pDataPer = calculatePercentile(pData);
            pData.pDataPer = pDataPer;
            return {
                ...state,
                playerData: { pData },
                mode: (findMode(pDataPer) ? 'live' : state.mode)
            };
        }
        case LIVE_SCORE_FETCH_DATA_SUCCESS: {
            const liveData = action.payload['Data']['Value'] || [];
            const pData = state.playerData.pData;
            if (state.isPlayerCardVisible) {
                const liveScore = liveData;
                const playerId = pData.Id;
                for (let i = 0; i < liveScore.length; i++) {
                    const match = liveScore[i];
                    const Mid = match.MID;
                    const liveScoreLine = match.ScoreLine;
                    const livePointsPlayer = filter(match.PPoints, { PID: playerId });
                    const liveStatsPlayer = filter(match.PStats, { PID: playerId });
                    if (livePointsPlayer.length > 0) {
                        const playerPoints = pData.Points;
                        const playerStats = pData.Stats;
                        const playerFixtures = pData.Fixtures;
                        for (let j = 0; j < playerPoints.length; j++) {
                            let plyrPoints = playerPoints[j];
                            if (+plyrPoints["MID"] === +Mid) {
                                const mergeContent = makeObj(livePointsPlayer[0]);
                                plyrPoints = merge(plyrPoints, mergeContent);
                                break;
                            }
                        }
                        for (let j = 0; j < playerStats.length; j++) {
                            let plyrStats = playerStats[j];
                            if (+plyrStats["MID"] === +Mid) {
                                const mergeContent = makeObj(liveStatsPlayer[0]);
                                plyrStats = merge(plyrStats, mergeContent);
                                break;
                            }
                        }
                        for (let j = 0; j < playerFixtures.length; j++) {
                            let plyrFixtures = playerFixtures[j];
                            if (+plyrFixtures["MID"] === +Mid) {
                                let plyrFixtures = playerFixtures[j];
                                if (+liveScoreLine[0].TID === +plyrFixtures.HTID) {
                                    plyrFixtures.HTScr = liveScoreLine[0].GS;
                                    plyrFixtures.ATScr = liveScoreLine[1].GS;
                                } else if (+liveScoreLine[0].TID === +plyrFixtures.ATID) {
                                    plyrFixtures.HTScr = liveScoreLine[1].GS;
                                    plyrFixtures.ATScr = liveScoreLine[0].GS;
                                }
                                plyrFixtures.MMinutes = match.MinuteString;
                                plyrFixtures.Phase = match.Phase;
                                plyrFixtures.liveStatus = match.Status;
                                break;
                            }
                        }
                    }
                }
                pData.pDataPer = calculatePercentile(pData);
                pData.hasAddedLiveScoringData = true;
            }
            return {
                ...state,
                liveScore: { ...state.liveScore, response: liveData },
                playerData: { pData }
            };
        }
        case IS_LIVE_SCORE_LOADING: {
            return { ...state, liveScore: { ...state.liveScore, isFetching: action.payload } };
        }
        case LIVE_SCORE_HAS_ERROR: {
            return { ...state, hasError: action.payload };
        }
        case IS_FIXTURE_LOADING: {
            return {
                ...state,
                fixtures: [],
                isPlayerCardVisible: false,
                isFixtureLoading: action.payload,
            };
        }
        case FIXTURE_HAS_ERROR: {
            return {
                ...state,
                isFixtureError: action.payload,
            };
        }
        case IS_USER_PLAYED_GAME_DAYS_LOADING: {
            return {
                ...state,
                userPlayedMatchDays: [],
                userSpecificFixtures: [],
                isUserPlayedGameDaysLoading: action.payload,
            };
        }
        case USER_PLAYED_GAME_DAYS_HAS_ERROR: {
            return {
                ...state,
                isUserPlayedGameDaysError: action.payload,
            };
        }
        case IS_GET_TEAM_LOADING: {
            return {
                ...state,
                isGetTeamLoading: action.payload,
            };
        }
        case GET_TEAM_HAS_ERROR: {
            return {
                ...state,
                isGetTeamError: action.payload,
            };
        }
        case FIXTURE_FETCH_DATA_SUCCESS: {
            const fixtures = action.payload['Data']['Value'] || [];
            return {
                ...state,
                fixtures,
            };
        }
        case GET_USER_SPECIFIC_FIXTURES: {
            const matchDayID = +action.payload;
            const { fixtures, userPlayedMatchDays } = state;
            const userSpecificFixtures = getFixturesToPrint(fixtures, userPlayedMatchDays);
            let currentActiveFixture = 0;
            if (matchDayID) {
                currentActiveFixture = findIndex(userSpecificFixtures, { GDID: matchDayID });
            } else {
                currentActiveFixture = findIndex(userSpecificFixtures, { selected: true });
            }
            return {
                ...state,
                currentActiveFixture,
                userSpecificFixtures
            };
        }
        case USER_PLAYED_GAME_DAYS_FETCH_DATA_SUCCESS: {
            const userPlayedMatchDays = action.payload['Data']['Value'] || [];
            return {
                ...state,
                userPlayedMatchDays,
            };
        }
        case GET_TEAM_FETCH_DATA_SUCCESS: {
            const team = action.payload['Data']['Value'];
            return {
                ...state,
                getTeam: team,
            };
        }
        case UPDATE_CURRENT_ACTIVE_FIXTURE: {
            return {
                ...state,
                currentActiveFixture: action.payload,
            };
        }
        case CREATE_MANAGE_TEAM_SKELETON: {
            const { getTeam, players, formations } = state;
            const { teamData, updatedFormations } = makeManageTeamSkeleton(getTeam, players, formations);
            const fwd = teamData['4'].length;
            const mid = teamData['3'].length;
            const def = teamData['2'].length;
            const defaultFormation = find(formations, {
                DEF: def,
                MID: mid,
                FWD: fwd,
            });
            const defaultFormationIndex = defaultFormation.CompId;
            common.setLocalStorage('defaultFormation', defaultFormation);
            common.setLocalStorage('defaultFormationIndex', defaultFormationIndex);
            const manageTeamRawData = clone(teamData);
            const { highlightedSkill } = teamData;
            const lastSkill = getLastSkill(highlightedSkill);
            const playerListRaw = state.groupedPlayers[lastSkill || config.EnumPosition.Forwards];
            const playerList = filterList(playerListRaw, state.playerFilters);
            saveMyTeamData(teamData);
            return {
                ...state,
                playerList,
                getTeam,
                teamData,
                formations: updatedFormations,
                manageTeamRawData,
                defaultFormation,
                defaultFormationIndex
            };
        }
        case SET_MANAGE_TEAM_MODE: {
            const mode = action.payload;
            return {
                ...state,
                manageTeamMode: mode,
            };
        }
        case RESET_TRANSFERS: {

            const teamData = clone(state.manageTeamRawData);
            if (Object.keys(teamData).length !== 0) {
                const { getTeam, players, formations } = state;
                const manageTeamResponse = makeManageTeamSkeleton(getTeam, players, formations);
                const oldTeamData = manageTeamResponse.teamData;
                const fwd = oldTeamData['4'].length;
                const mid = oldTeamData['3'].length;
                const def = oldTeamData['2'].length;
                const defaultFormation = find(formations, {
                    DEF: def,
                    MID: mid,
                    FWD: fwd,
                });
                const defaultFormationIndex = defaultFormation.CompId;
                common.setLocalStorage('defaultFormation', defaultFormation);
                common.setLocalStorage('defaultFormationIndex', defaultFormationIndex);
                const { highlightedSkill } = teamData;
                const lastSkill = getLastSkill(highlightedSkill);
                // const playerListRaw = state.groupedPlayers[lastSkill];
                const playerListRaw = state.players;
                const playerList = filterList(playerListRaw, state.playerFilters);
                return {
                    ...state,
                    teamData,
                    playerList,
                    defaultFormation: defaultFormation,
                    defaultFormationIndex: defaultFormationIndex,
                };
            } else {
                return {
                    ...state,
                    teamData,
                };
            }
        }
        case SUBSTITUTE_THIS_PLAYER: {
            let { teamData } = state;
            const player = action.payload;
            const teamDataWithSubsState = substituteThisPlayer(teamData, player);
            return {
                ...state,
                teamData: teamDataWithSubsState,
            };
        }
        case REPLACE_WITH_THIS_PLAYER: {
            let { teamData, manageTeamRawData, formations } = state;
            const player = action.payload;
            const teamDataWithSubsState = replaceWithThisPlayer(teamData, manageTeamRawData, player);
            const fwd = teamDataWithSubsState['4'].length;
            const mid = teamDataWithSubsState['3'].length;
            const def = teamDataWithSubsState['2'].length;
            const defaultFormation = find(formations, {
                DEF: def,
                MID: mid,
                FWD: fwd,
            });
            const defaultFormationIndex = defaultFormation.CompId;
            if (!common.isManageTeam()) {
                saveMyTeamData(teamDataWithSubsState);
            }
            common.setLocalStorage('defaultFormation', defaultFormation);
            common.setLocalStorage('defaultFormationIndex', defaultFormationIndex);
            return {
                ...state,
                teamData: teamDataWithSubsState,
                defaultFormation,
                defaultFormationIndex
            };
        }
        case RESET_SUBSTITUTION: {
            let { teamData } = state;
            const resetSubTeamData = resetSubstitution(teamData);
            return {
                ...state,
                teamData: resetSubTeamData,
            };
        }
        case CANCEL_SUBSTITUTION: {
            let { teamData } = state;
            const cancelSubTeamData = cancelSubstitution(teamData);
            return {
                ...state,
                teamData: cancelSubTeamData,
            };
        }
        case RESET_TEAM_DATA: {
            localStorage.removeItem('teamData');
            return {
                ...state,
                teamData: {},
            };
        }
        case RESET_CREATE_TEAM_ERROR: {
            return {
                ...state,
                savedTeamData: {
                    response: {},
                    error: false,
                    isFetching: false
                }
            };
        }
        case IS_TRANSFER_TEAM_LOADING: {
            return { ...state, savedTransferData: { ...state.savedTransferData, isFetching: action.payload } };
        }
        case TRANSFER_TEAM_HAS_ERROR: {
            return { ...state, savedTransferData: { ...state.savedTransferData, error: action.payload } };
        }
        case TRANSFER_TEAM_FETCH_DATA_SUCCESS: {
            return { ...state, savedTransferData: { ...state.savedTransferData, response: action.payload } };
        }
        case IS_LIMITLESS_TEAM_LOADING: {
            return { ...state, savedLimitlessData: { ...state.savedLimitlessData, isFetching: action.payload } };
        }
        case LIMITLESS_TEAM_HAS_ERROR: {
            return { ...state, savedLimitlessData: { ...state.savedLimitlessData, error: action.payload } };
        }
        case LIMITLESS_TEAM_FETCH_DATA_SUCCESS: {
            return { ...state, savedLimitlessData: { ...state.savedLimitlessData, response: action.payload } };
        }
        case IS_SUBSTITUTION_TEAM_LOADING: {
            return { ...state, savedSubstitutionData: { ...state.savedSubstitutionData, isFetching: action.payload } };
        }
        case SUBSTITUTION_TEAM_HAS_ERROR: {
            return { ...state, savedSubstitutionData: { ...state.savedSubstitutionData, error: action.payload } };
        }
        case SUBSTITUTION_TEAM_FETCH_DATA_SUCCESS: {
            return { ...state, savedSubstitutionData: { ...state.savedSubstitutionData, response: action.payload } };
        }
        case REMOVE_ALL: {
            const teamData = state.teamData;
            return { ...state, teamData: resetAll(teamData) };
        }
        case IS_CAPTAIN_LOADING: {
            return { ...state, savedCaptainData: { ...state.savedCaptainData, isFetching: action.payload } };
        }
        case CAPTAIN_HAS_ERROR: {
            return { ...state, savedCaptainData: { ...state.savedCaptainData, error: action.payload } };
        }
        case CAPTAIN_FETCH_DATA_SUCCESS: {
            return { ...state, savedCaptainData: { ...state.savedCaptainData, response: action.payload } };
        }
        case UPDATE_BOOSTER_STATUS: {
            const { key, value } = action.payload;
            const teamData = { ...state.teamData };
            teamData[key] = value;
            return { ...state, teamData: teamData };
        }
        case SET_POPUP_STATE: {
            const states = action.payload;
            return {
                ...state,
                popupState: states,
            };
        }
        case SET_BOOSTER_POPUP_STATE: {
            const states = action.payload;
            return {
                ...state,
                boosterPopupState: states,
            };
        }
        case UPDATE_SAVE_BTN_STATUS: {
            return {
                ...state,
                saveBtnStatus: action.payload,
            };
        }
        case SUBSCRIBE_INFO_FETCH_DATA_SUCCESS: {
            const subscribeInfo = action.payload['Data']['Value'];
            return {
                ...state,
                subscribeInfo,
            };
        }
        case IS_SUBSCRIBE_INFO_LOADING: {
            return {
                ...state,
                isSubscribeInfoLoading: action.payload,
            };
        }
        case SUBSCRIBE_INFO_HAS_ERROR: {
            return {
                ...state,
                subscribeInfoHasError: action.payload,
            };
        }
        case IS_UPDATED_TEAM_NAME_LOADING: {
            return { ...state, updateTeamNameData: { ...state.updateTeamNameData, isFetching: action.payload } };
        }
        case UPDATED_TEAM_NAME_HAS_ERROR: {
            return { ...state, updateTeamNameData: { ...state.updateTeamNameData, error: action.payload } };
        }
        case UPDATED_TEAM_NAME_FETCH_DATA_SUCCESS: {
            return { ...state, updateTeamNameData: { ...state.updateTeamNameData, response: action.payload } };
        }
        case IS_DELETE_FANTASY_TEAM_LOADING: {
            return { ...state, deleteFantasyTeamData: { ...state.deleteFantasyTeamData, isFetching: action.payload } };
        }
        case DELETE_FANTASY_TEAM_HAS_ERROR: {
            return { ...state, deleteFantasyTeamData: { ...state.deleteFantasyTeamData, error: action.payload } };
        }
        case DELETE_FANTASY_TEAM_FETCH_DATA_SUCCESS: {
            return { ...state, deleteFantasyTeamData: { ...state.deleteFantasyTeamData, response: action.payload } };
        }
        case TRIGGER_HANDLE_FIXTURE_POPUP: {
            return {
                ...state,
                isFixturePopupVisible: action.payload.isFixturePopupVisible,
            }
        }
        case MIX_FETCH_DATA_SUCCESS: {
            return {
                ...state,
                mixResponse: action.payload['Data']['Value'],
            }
        }
        case SET_TEAM_LOCK_TOAST_COOKIE: {
            const name = action.payload;
            let obj = {};
            const teamLockToastKeys = common.getLocalStorage('teamLockToastKeys');
            if (teamLockToastKeys) {
                let newObj = JSON.parse(teamLockToastKeys);
                if (name && !newObj[name]) {
                    newObj[name] = true;
                }
                ;
                obj = newObj;
            } else {
                obj[name] = true;
            }
            common.setLocalStorage('teamLockToastKeys', JSON.stringify(obj));
            return { ...state };
        }
        case IS_MATCH_DETAILS_LOADING: {
            return {
                ...state,
                matchDetails: {},
                isMatchDetailsLoading: action.payload,
            };
        }
        case MATCH_DETAILS_HAS_ERROR: {
            return {
                ...state,
                matchDetailsHasError: action.payload,
                isMatchDetailsLoading: false
            };
        }
        case MATCH_DETAILS_FETCH_DATA_SUCCESS: {
            const matchDetails = action.payload['Data']['Value'] || {};
            return {
                ...state,
                matchDetails,
                isMatchDetailsLoading: false
            };
        }

        case IS_SHARE_TEAM_LOADING: {
            return {
                ...state,
            };
        }
        case TEAM_SHARE_SUCCESS: {
            common.hideLoader();
            return {
                ...state,
                shareUrl: action.payload['Data'] ? action.payload['Data']['Value'] ? action.payload['Data']['Value'] : "" : ""
            };
        }
        case TEAM_SHARE_ERROR: {
            common.hideLoader();
            return {
                ...state,
                shareUrl: ""
            };
        }

        case TEAM_SHARE_CLEAR: {
            return {
                ...state,
                shareUrl: ""
            };
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/FormationsReducer.js